import { reduceRight } from "lodash";
import {UPDATE_EXTENSION, TOGGLE_ZSTACK_SCREENSHOT, UPDATE_BARCODE_IMG_ROTATION} from "../redux_constants/screenshot.state.constant";

const initialState = {
	extension: '.jpeg',
	updated: false,
	zStackScreenshotEnabled: true,
	barcodeImgCurrentRotation: 270,
}

export const screenshotStateReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_EXTENSION:
			return Object.assign({}, state, {
				extension: action.extension,
			});
		case TOGGLE_ZSTACK_SCREENSHOT:
			return Object.assign({}, state, {
				zStackScreenshotEnabled: action.zStackScreenshotEnabled,
			});
		case UPDATE_BARCODE_IMG_ROTATION:
			let rotation = parseInt(action.rotation, 10)
			if (isNaN(rotation)) {
				rotation = 270;
			}
			return Object.assign({}, state, {
				barcodeImgCurrentRotation: rotation
			});
		default:
			return state;
	}
}
